import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
// images
import LandingImg from '../../images/landing.png';
// react-bootstrap
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Image from 'react-bootstrap/Image';
import Button from 'react-bootstrap/Button';
// components
import LoadingScreen from '../../components/LoadingScreen';
// helper
import { getUser } from '../../utils/helpers';

const Landing = () => {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  // check if there is user to navigate to home page
  useEffect(() => {
    const checkUser = () => {
      const user = getUser();
      if (!user) {
        setLoading(false);
        return;
      }

      navigate('/home');
    };

    setTimeout(() => {
      checkUser();
    }, 1500);
  }, [navigate]);

  return (
    <Container className={'mt-5'}>
      {loading && (
        <div className='mx-auto mt-5 pt-5'>
          <LoadingScreen />
        </div>
      )}
      {!loading && (
        <div>
          <Row>
            <Col xs={12} md={12} lg={6} className={'mt-5'}>
              <h1 className={'mt-5'} style={{ color: 'var(--black)' }}>
                <span style={{ color: 'var(--brandSecondary)' }}>track</span>{' '}
                your reads,
              </h1>
              <h1 style={{ color: 'var(--black)' }}>
                <span style={{ color: 'var(--brandSecondary)' }}>create</span>{' '}
                your books shelf,
              </h1>
              <h1 style={{ color: 'var(--black)' }}>
                <span style={{ color: 'var(--brandSecondary)' }}>find</span> and{' '}
                <span style={{ color: 'var(--brandSecondary)' }}>discover</span>{' '}
                best seller and trends
              </h1>
              <h1 className={'mt-5'} style={{ color: 'var(--black)' }}>
                all that is{' '}
                <span
                  style={{ color: 'var(--brandSecondary)', fontSize: '2.5rem' }}
                >
                  FREE.
                </span>
              </h1>
            </Col>
            <Col xs={12} md={12} lg={6} className={'mt-5'}>
              <Image src={LandingImg} fluid />
            </Col>
          </Row>
          <Row className={'mt-5 mb-3 text-center'}>
            <h1 className={'mt-5'} style={{ color: 'var(--black)' }}>
              Already have an account?
              <Button
                size='lg'
                className={'ms-4 px-5'}
                style={{
                  backgroundColor: 'var(--brandSecondary)',
                  borderRadius: '12px',
                }}
                onClick={() => {
                  navigate('/login');
                }}
              >
                Login
              </Button>
            </h1>
            <h1 style={{ color: 'var(--black)' }} className={'mt-5'}>
              Don't have an account?
              <Button
                size='lg'
                variant='outline-danger'
                className={'ms-4 px-5'}
                style={{
                  borderRadius: '12px',
                }}
                onClick={() => {
                  navigate('/sign-up');
                }}
              >
                Sign Up
              </Button>
            </h1>
          </Row>
        </div>
      )}
    </Container>
  );
};

export default Landing;
